// types
import type { StrapiSiteSeo } from '@ts-strapi/interfaces'
import type { JsonLdNode } from '@ts-structured-data/types'

interface BuildWebsiteOptions {
  siteSeo: StrapiSiteSeo | null
  origin: string
}

export const buildWebsite = ({ siteSeo, origin }: BuildWebsiteOptions): JsonLdNode | null => {
  if (!siteSeo) return null

  return {
    '@type': 'WebSite',
    '@id': `${origin}/#website`,
    url: `${origin}/`,
    name: siteSeo.organizationName,
    publisher: { '@id': `${origin}/#organization` },
    inLanguage: 'en-US',
  }
}
